import * as React from 'react';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';

import CloudUploadIcon from '@mui/icons-material/CloudUpload';

export default function index({...rest}) {
    return (
        <Stack direction="row" alignItems="center" spacing={2}>
            <Button variant="contained" component="label"
                className='secondary-button'
                sx={{boxShadow: "none"}}
            >
                <CloudUploadIcon sx={{ mr: '10px' }} />
                Upload file
                <input hidden accept="/*" multiple type="file" {...rest} />
            </Button>
        </Stack>
    );
}